__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/cc05766/_next/";